/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  containerPadding: {
    padding: '24px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
  },

  buyerDetailsHolder: {},

  buyerDetailsHolderWithBorder: {
    borderTop: `8px solid ${theme.palette.primary.borderColor}`,
  },

  documentsHolder: {
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },

  addRepresentativeHolder: {},

  transactionShareGridItem: {},
  transactionShareTextOne: {
    display: 'block',
    color: theme.palette.primary.adgmBlack,
    fontSize: '16px',
    fontWeight: 600,
  },
  transactionShareValue: {
    color: theme.palette.primary.main,
  },
  transactionShareTextTwo: {
    display: 'block',
    color: theme.palette.primary.adgmBlack,
    fontSize: '16px',
    fontWeight: 600,
  },
});

export default styles;
